import * as React from 'react';
import axios from 'axios';

import { PropertyAnnouncementType } from './types';

import Loading from '../../react-common/Loading';
import OfferMessageList from './OfferMessageList';
import OfferMessageDetailContainer from './OfferMessageDetailContainer';

interface OfferMessageSentPageProps {
  listingId: string;
}

interface OfferMessageSentPageState {
  dataLoaded: boolean;
  selectedPropertyAnnouncement: PropertyAnnouncementType;
  propertyAnnouncements: PropertyAnnouncementType[];
}

class OfferMessageSentPage extends React.Component<
  OfferMessageSentPageProps,
  OfferMessageSentPageState
> {
  constructor(props: OfferMessageSentPageProps) {
    super(props);

    this.state = {
      dataLoaded: false,
      selectedPropertyAnnouncement: null,
      propertyAnnouncements: [],
    };
  }

  async componentDidMount() {
    const { propertyAnnouncements } = await this.fetchData();

    this.setState({
      propertyAnnouncements,
      dataLoaded: true,
    });
  }

  async fetchData() {
    const { listingId } = this.props;
    const { data: propertyAnnouncements } = await axios.get(
      `/listing/${listingId}/offer_message`,
    );

    return {
      propertyAnnouncements,
    };
  }

  onPropertyAnnouncementSelected = (id: string) => {
    this.setState({
      selectedPropertyAnnouncement: this.state.propertyAnnouncements.find(
        propertyAnnouncement => propertyAnnouncement.id === id,
      ),
    });
  };

  render() {
    const { listingId } = this.props;
    const { dataLoaded, propertyAnnouncements, selectedPropertyAnnouncement } =
      this.state;

    return !dataLoaded ? (
      <Loading size="fa-5x" />
    ) : (
      <div className="row m-t-lg">
        <div className="col-md-4">
          <OfferMessageList
            propertyAnnouncements={propertyAnnouncements}
            onPropertyAnnouncementSelected={this.onPropertyAnnouncementSelected}
            selectedPropertyAnnouncement={selectedPropertyAnnouncement}
          />
        </div>
        <div className="col-md-8">
          <OfferMessageDetailContainer
            listingId={listingId}
            propertyAnnouncement={selectedPropertyAnnouncement}
          />
        </div>
      </div>
    );
  }
}

export default OfferMessageSentPage;
